import React from 'react';
import { number, string } from 'prop-types';

import css from './MobileHomeIcons.module.css';

export const ArrowLinkIcon = props => {
  const { size, strokeWidth, className } = props;

  return (
    <svg
      className={className || css.arrowLinkIcon}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="13 6 19 12 13 18" fill="none" />
    </svg>
  );
};

ArrowLinkIcon.defaultProps = {
  size: 13,
  strokeWidth: 2.6,
  className: null,
};

ArrowLinkIcon.propTypes = {
  size: number,
  strokeWidth: number,
  className: string,
};

export const ChevronGoIcon = props => {
  const { className } = props;

  return (
    <svg
      className={className || css.chevronGoIcon}
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="9 5 16 12 9 19" fill="none" />
    </svg>
  );
};

ChevronGoIcon.defaultProps = {
  className: null,
};

ChevronGoIcon.propTypes = {
  className: string,
};
